import { Component, OnInit, Inject, HostListener, ElementRef, Output, Input, EventEmitter, DOCUMENT } from '@angular/core';
import { JsonService } from 'src/app/services/core/json.service';


@Component({
    selector: 'app-module-office-selection',
    templateUrl: './module-office-selection.component.html',
    styleUrls: ['./module-office-selection.component.scss'],
    standalone: false
})
export class ModuleOfficeSelectionComponent implements OnInit {

  public userDetail:any = null;
  public companyListSelection: any = [];
  public groupOffices: any = [];
  currentCompanyId: any = 0;
  public lastSelectedOffices: any = []
  showOfficePanel = false;
  public isSettingChange = false;

  @Output() callback = new EventEmitter<any>();
  @Input() model: any = {}
  @Input() isEdit = false;

  constructor(public jsonService: JsonService,
    @Inject(DOCUMENT) private document: Document,
    private element: ElementRef,
  ) { }

  ngOnInit(): void {



    this.userDetail = this.jsonService.doParse(localStorage.getItem("auth_detail"))

    if (this.isEdit) {
      const currentCompany = this.model?.tenants.find((tenant: any) => tenant.is_default === 1);

      // Set currentCompanyId: use default company if available, otherwise first tenant ID
      this.currentCompanyId = currentCompany?.id || this.model?.tenants[0]?.id;

      // Collect last selected offices, excluding current company
      this.lastSelectedOffices = this.model?.tenants
        .filter((tenant: any) => tenant.id !== this.currentCompanyId)
        .map((tenant: any) => tenant.id) || [];
    } else {
      this.groupOffices = this.groupCompanies(this.userDetail.attach_tenents);
      this.lastSelectedOffices = this.userDetail.selected_tenents?.map((tenant: any) => tenant?.id)

      this.userDetail.attach_tenents.forEach((element: any) => {
        this.companyListSelection.push({
          name: element.name,
          value: element.id,
          selected: this.lastSelectedOffices.includes(element.id),
        });
      });

      this.currentCompanyId = this.userDetail.current_tenent.id;
    }


    this.onOfficeSettingApply()

  }

  groupCompanies(data: any[]): any[] {
    const result: any[] = [];
    const companyMap = new Map<number, any>();

    // Create a map for easy lookup by id
    data.forEach(company => companyMap.set(company.id, company));

    // Recursive function to find and nest children
    const findChildren = (parentId: number, visited: Set<number>): any[] => {
      if (visited.has(parentId)) return []; // Prevent circular references
      visited.add(parentId);

      const children = data.filter(company =>
        company.selected_options.includes(parentId) && company.id !== parentId
      );

      if (children.length === 0) return []; // Base case: no more children

      return children.map(child => ({
        ...child,
        children: findChildren(child.id, new Set(visited)) // Recursively find children
      }));
    };

    // Find parents and nest their children
    data.forEach(company => {
      if (company.is_parent) {
        result.push({
          ...company,
          children: findChildren(company.id, new Set())
        });
      }
    });


    return this.clearChildrenIfNotParent(result);
  }

  clearChildrenIfNotParent(data: any[]): any[] {
    data.forEach(item => {
      if (!item.is_parent) {
        item.children = []; // Empty the children array if is_parent is false
      } else if (item.children && item.children.length > 0) {
        this.clearChildrenIfNotParent(item.children); // Recurse for nested children
      }
    });
    return data;
  }


  getSelectedCompanyName(): string {
    const selectedCompany = this.companyListSelection.find((tenant: any) => tenant.value == this.currentCompanyId);
    return selectedCompany ? selectedCompany.name : 'Select Office';
  }


  toggleOfficePanel(): void {
    if(this.companyListSelection.length < 1) {
        return
    }
    this.showOfficePanel = !this.showOfficePanel;
  }

  setDefaultOffice(id:any) {
    this.isSettingChange = true;
    if (this.lastSelectedOffices.length === 0) {
      this.lastSelectedOffices.push(id);
      this.currentCompanyId = id;
    } else {
      const firstItemId = this.lastSelectedOffices[0];
      const firstOption = this.userDetail.attach_tenents.find((tenant: any) => tenant.id === firstItemId);

      const isInSelectedOptions = firstOption.selected_options?.includes(id)
      if (isInSelectedOptions) {
        if (this.lastSelectedOffices.includes(id)) {
          this.currentCompanyId = id;
          // this.lastSelectedOffices = this.lastSelectedOffices.filter((item:any) => item !== id);
        } else {
          this.lastSelectedOffices.push(id);
          this.currentCompanyId = id;
        }
      } else {
          // this.snackBar.open('The last selected office is of a different type, so your previously selected offices have been deselected.', '', {
          //   duration: 3000,
          //   horizontalPosition: 'end',
          //   verticalPosition: 'top',
          // });
        this.lastSelectedOffices = [id];
        this.currentCompanyId = id;

      }
    }

  }

  selectOffice(id:any) {
    this.isSettingChange = true;
    if (this.lastSelectedOffices.length === 0) {
      this.lastSelectedOffices.push(id);
    } else {
      const firstItemId = this.lastSelectedOffices[0];
      const firstOption = this.userDetail.attach_tenents.find((tenant: any) => tenant.id === firstItemId);

      const isInSelectedOptions = firstOption.selected_options?.includes(id)
      if (isInSelectedOptions) {
        if (this.lastSelectedOffices.includes(id)) {
          if(id != this.currentCompanyId) {
            this.lastSelectedOffices = this.lastSelectedOffices.filter((item:any) => item !== id);
          }

        } else {
          this.lastSelectedOffices.push(id);
        }
      } else {
          // this.snackBar.open('The last selected office is of a different type, so your previously selected offices have been deselected.', '', {
          //   duration: 3000,
          //   horizontalPosition: 'end',
          //   verticalPosition: 'top',
          // });
        this.lastSelectedOffices = [id];
        this.currentCompanyId = id;

      }
    }
  }

  closeOfficePanel(): void {
    if(this.isSettingChange) {
      this.onOfficeSettingApply()
    }
    this.isSettingChange = false;
    this.showOfficePanel = false;
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: HTMLElement): void {
    const clickedInside = this.element.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.closeOfficePanel();
    }
  }

  onOfficeSettingApply() {
    let data = {
      select_tenents: this.lastSelectedOffices,
      current_tenent: this.currentCompanyId,
    }
    this.callback.emit(data);

  }


}
